var cov_2ithzpel97 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/popContainer.ts",
      hash = "6991fae042b3a4cb8d0047b9c6b0310656e94aec",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/popContainer.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 36
        },
        end: {
          line: 7,
          column: 40
        }
      },
      "1": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "3": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 20
        }
      },
      "4": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 43
        }
      },
      "5": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 100
        }
      },
      "6": {
        start: {
          line: 15,
          column: 17
        },
        end: {
          line: 15,
          column: 38
        }
      },
      "7": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 31
        }
      },
      "8": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 21
          },
          end: {
            line: 9,
            column: 22
          }
        },
        loc: {
          start: {
            line: 9,
            column: 27
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 15
          }
        }, {
          start: {
            line: 10,
            column: 19
          },
          end: {
            line: 10,
            column: 42
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

/**
 * 最外层容器
 */
import { isInDocument } from './isInDocument';
import { getDefaultContainer } from '../../config';
var Container = (cov_2ithzpel97.s[0]++, null);
cov_2ithzpel97.s[1]++;

var getContainer = function getContainer() {
  cov_2ithzpel97.f[0]++;
  cov_2ithzpel97.s[2]++;

  if ((cov_2ithzpel97.b[1][0]++, Container) && (cov_2ithzpel97.b[1][1]++, isInDocument(Container))) {
    cov_2ithzpel97.b[0][0]++;
    cov_2ithzpel97.s[3]++;
    return Container;
  } else {
    cov_2ithzpel97.b[0][1]++;
  }

  cov_2ithzpel97.s[4]++;
  Container = document.createElement('div');
  cov_2ithzpel97.s[5]++;
  Container.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; contain: size');
  var target = (cov_2ithzpel97.s[6]++, getDefaultContainer());
  cov_2ithzpel97.s[7]++;
  target.appendChild(Container);
  cov_2ithzpel97.s[8]++;
  return Container;
};

export default getContainer;